module.exports = __webpack_public_path__ + "static/media/fps.02d2840e.png";